import { resolveContextActions } from "../helpers/permissionsActions/resolveContextActions";
import { useUserRoles } from "./useUserRoles";


export const useContextActions = ({ context, screen }) => {
  const roles = useUserRoles();

  return resolveContextActions({
    roles,
    context,
    screen,
  });
};
